import fp from 'lodash/fp';
import React, { FC } from 'react';
import { InputAdornment, TextField, inputBaseClasses } from '@mui/material';

import { Search24 } from '../../../icons';


export type SearchProps = {
    placeholder: string;
    value?: string;
    onChange: (value: string) => void;
};

export const Search: FC<SearchProps> = ({ placeholder, value, onChange }) => (
    <TextField
        variant='filled'
        fullWidth
        placeholder={placeholder}
        hiddenLabel
        value={fp.isString(value) ? value : undefined}
        sx={{
            p: 2,

            [`& .${inputBaseClasses.input}`]: {
                pt: 4,
            },
        }}
        onChange={e => onChange(e.target.value)}
        InputProps={{
            startAdornment: (
                <InputAdornment position='start'>
                    <Search24 />
                </InputAdornment>
            ),
        }}
    />
);
